/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Remote_NoticeInputs */



/**
* | output |
* | --- |
* | "A connected application is currently controlling the watermark for this session." |
*
* @param {Options_Watermark_Remote_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_remote_notice = /** @type {((inputs?: Options_Watermark_Remote_NoticeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Remote_NoticeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une application connectée contrôle actuellement le filigrane pour cette session.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine verbundene Anwendung steuert derzeit das Wasserzeichen für diese Sitzung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un'applicazione collegata sta attualmente controllando la filigrana per questa sessione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключённое приложение сейчас управляет водяным знаком в этом сеансе.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una aplicación conectada está controlando la marca de agua en esta sesión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已连接的应用程序当前正在控制本次会话的水印。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続中のアプリケーションがこのセッションのウォーターマークを制御しています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक कनेक्टेड एप्लिकेशन इस सत्र के वॉटरमार्क को नियंत्रित कर रहा है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Uma aplicação ligada está atualmente a controlar a marca de água nesta sessão.")
	return /** @type {LocalizedString} */ ("A connected application is currently controlling the watermark for this session.")
});